import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { userLogin } from '../../store/actions/apiActions'
import { Jackpots } from '../Mobile/Mobile'
import st from './JackpotPageRestyled.module.scss'

const JackpotPageRestyled = () => {
	const dispatch = useDispatch()
	const userData = useSelector((state) => state?.userdata, shallowEqual)

	useEffect(() => {
		if (!userData.auth) {
			// anonymous session: this page is embedded standalone in iframes and only
			// needs the jackpot feed, so it must never register as the real account's
			// active session, which would kick that session as a "parallel" login
			dispatch(userLogin(true))
		}

		// Set the background to transparent
		document.body.style.background = 'transparent'

		return () => {
			document.body.style.background = ''
		}
	}, [])

	return (
		<div className={st.jackpotWrapperOuter}>
			<Jackpots
				className={st.jackpot}
				wrapperClass={st.jackpotWrapperInner}
			/>
		</div>
	)
}

export default JackpotPageRestyled
